<template>
  <div class="c-app">
    <TheSidebar />
    <CWrapper>
      <TheHeader />
      <div class="c-body">
        <main class="c-main p-0">
          <CContainer fluid class="p-0" v-if="areHoodsLoaded">
            <router-view></router-view>
          </CContainer>
        </main>
      </div>
      <TheFooter />
    </CWrapper>
  </div>
</template>

<script>
import TheSidebar from "./TheSidebar";
import TheHeader from "./TheHeader";
import TheFooter from "./TheFooter";
import { estateAdService } from "../services/services";

export default {
  name: "TheContainer",
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
  },
  data: function() {
    return {
      areHoodsLoaded: false,
    };
  },
  mounted() {
    let loading = this.$loading.show();
    estateAdService
      .getAllHoods()
      .then((hoodsResponse) => {
        this.$store.commit("setHoods", hoodsResponse.body);
        this.areHoodsLoaded = true;
      })
      .catch(() => {})
      .finally(() => loading.hide());
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
p {
  margin: 0;
}

.btn {
  margin: 5px;
}
</style>
